import {useRef} from "react";
import { useState, useEffect } from 'react';
import { Spin } from 'antd';
import TableComponent from '../../../../components/table';
import PaginationComponent from '../../../../components/pagination';
import Api from "../../../../services/api";
import { networkIcons } from "../../../../utility";

const AppCampaignPerformance = (props) => {
  const [appCampaignPerformance,setAppCampaignPerformance] = useState({});
  const [page,setPage] = useState(1);
  const [sort,setSort] = useState({});
  const [loading,setLoading] = useState(false);
  const [filterName, setFilterName] = useState('');
  const [] = useState(null);
  const prevParamsRef = useRef("");

  useEffect(() => {

    const currentParams = JSON.stringify({
      os: props.os,
      from: props.startDate.format('YYYY-MM-DD'),
      to: props.endDate.format('YYYY-MM-DD'),
      code: props.code,
      country: props.country,
      ad_network: props.adnetwork,
      campaign: props.campaign,
      sort_value_by: props.sortValue,
      sort_by_column: sort.column || '',
      sort_by_column_value: sort.value || '',
      name: filterName,
      page: page
    });

    if (prevParamsRef.current === currentParams) return;

    prevParamsRef.current = currentParams;

    setLoading(true)
    Api.get(`api/overview_app/cost_by_campaign?os=${props.os}&from=${props.startDate.format('YYYY-MM-DD')}&to=${props.endDate.format('YYYY-MM-DD')}&code=${props.code}&country=${props.country}&ad_network=${props.adnetwork}&campaign=${props.campaign}&sort_value_by=${props.sortValue}&sort_by_column=${sort.column || ''}&sort_by_column_value=${sort.value || ''}&name=${filterName}&page=${page}`)
    .then(result => {
      if(result?.data?.code === 0){
        setAppCampaignPerformance(result.data)
        setLoading(false)
      }
    });
  }, [props.code,props.os,props.reload,props.startDate,props.endDate, props.sortValue,page,sort,filterName]);

  const handleChangePage = (page) => {
    setPage(page);
  }

  const handleSort = (key) => {
    const arr = key.split('-')
    setSort({
      column : arr[0],
      value : arr[1]
    })
  }

  const handleFilterName = (value, key) => {
    if (key === 'name') {
      setFilterName(value);
      setPage(1);
    }
  };

  return (
    <Spin spinning={loading}>
    <TableComponent 
      sort="1"
      filter={true}
      column={[{
        key : 'name',
        name : 'Name',
        customRender: (value, item) => {
          const displayValue = value?.value || value?.format || value;
          
          return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {item?.network?.value && networkIcons[item.network.value] && (
            <img 
              width="15px" 
              height="15px" 
              src={`/icon/${networkIcons[item.network.value]}`}
              alt={item.network.value}
              style={{ marginRight: '8px', borderRadius: "8px" }}
            />
            )}
            <span style={{ overflow : "hidden" , textOverflow: "ellipsis" , whiteSpace: "nowrap"}}>{displayValue}</span>
          </div>
          );
        }
      },{
        key : 'cost',
        name : 'Cost ($)',
      },{
        key : 'install',
        name : 'Installs',
      },{
        key : 'status',
        name : 'Status',
      }]}
      data={appCampaignPerformance.data || []}
      handleFilterName={handleFilterName}
      sort={handleSort}
    />
    <PaginationComponent 
      current={appCampaignPerformance.page}
      total={appCampaignPerformance.total_page}
      handleChangePage={handleChangePage} />
    </Spin>
  )
}
export default AppCampaignPerformance;